/** Sinks promise to avoid unhandled promise rejections */
export const sink = (value: Promise<any>) => {
  value.catch(noop)
}

const noop = () => {}
